<template>
	<div class="open-account-bank">
		<van-radio-group v-model="radio">
			<van-radio class="item" :name="p.qts_goods_id" style="width: 100%;" v-for="p in list" :key="p.qts_goods_id">
				<p>商品名：{{ p.name }}</p>
				<p>天数：{{ p. duration}}</p>
				<p>价格：{{ p. price}}</p>
			</van-radio>
		</van-radio-group>
		<div class="common_block">
				<van-button type="warning" block @click="deal">购买</van-button>
			</div>
	</div>
</template>

<script>
	export default {
		name: 'qts_goodslist',
		data() {
			return {
				token: '',
				radio: '',
				list:[]
				
			}
		},
		mounted() {
			
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
			}
			this.getList()
		},
		methods: {
			getList() {
				this.$axios({
					method: 'post',
					url: 'qts_qts/goodslist', 
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {
						this.list = res.data
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			},
			deal() {
				const item = this.list.find(p => p.qts_goods_id == this.radio)
				if(this.radio == '' || this.radio == undefined){
					this.$toast.fail('请选择商品')
					return
				}
				this.$dialog.confirm({
					title: '提示',
					message: '商品名称：'+item.name+'\n'+'商品价格：'+item.price+'\n需要使用余额购买'
				}).then(() => {
					// on confirm
					this.up()
				}).catch(() => {
            //点击取消按钮后的调用
          })
				
			},
			up(){
				this.$axios({
					method: 'post',
					url: 'qts_qts/deal', 
					data: {
						token: this.token,
						qts_goods_id: this.radio
					}
				}).then ((res) => {
					if (res.success) {
						this.$toast.success("购买成功")
						setTimeout(() => {
							this.$router.go(-1)
						}, 2000);
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			}
		},
	}
</script>
<style scoped>
	.item{
		padding: 10px;
		border-bottom: 1px solid #eee;
		background: white;
	}
</style>